import React from 'react';
import { RedeemProductContextData } from './types';

export const RedeemProductContext = React.createContext<RedeemProductContextData>(
  {} as RedeemProductContextData,
);

export default RedeemProductContext;
